define('modules/form/form_item_model',['backbone', 'jquery', '_'], function (Backbone, $, _) {
  'use strict';
  var Item = Backbone.Model.extend({
    defaults: function () {
      return {
        type: 'text',
        placeholder: '',
        value: '',
        maxlength: false,
        all: false, // only used with checkboxes,
        periods: false,
        label: '',
        label_sv: '',
        trigger_autosave: false,
        readonly: '',
        media_fact_connection: '',
        input_readonly: false,
        error: false,
        error_message: '',
      };
    },
  });
  return Item;
});

